// @ts-nocheck
// import '../../sass/global.scss'

import { loadSwiperSliderBeerInternal } from "../components/sliderBeerInternalSwiper";
import { loadSwiperSliderBeer } from "../components/sliderBeer";
import {
  sliderCampaigns,
  sliderInstagramCampaigns,
} from "../components/campaigns";
import { loadAnimations } from "./animations";
import { formregister } from "../components/formregister";

window.addEventListener("load", function () {
  sliderCampaigns();
  sliderInstagramCampaigns();
  loadSwiperSliderBeerInternal();
  loadSwiperSliderBeer();
  pacoLoginLogout();
  loadAnimations();
  formregister();
  menuHeaderActive();
  bannerMemesPerfil();
  // loginClickDatalayer()
  // registerClickDatalayer()
  deleteh2()
  /* dynamic-import --- webpackChunkName: "chunks/name" */
  // validateRoute("/") && import("../pages/home").then(({ page }) => page());
});

// const validateRoute = (path) => {
//   return window.location.pathname === path;
// };

function loginClickDatalayer(){
  const btn = document.querySelector("#edit-send") as any
  btn && btn.addEventListener("click", ()=>{
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Login',
      'event_action': 'Submit',
      'event_label': 'Email'
    })
  })
}

function registerClickDatalayer(){
  const btn = document.querySelector("#edit-submit") as any
  btn && btn.addEventListener("click", ()=>{
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Form',
      'event_action': 'Click',
      'event_label': 'Send',
      'interaction':'true',
      'component_name': "Botón Registrarme"
    })
  })
}

function bannerMemesPerfil(){
  let bannerPerfil = document.querySelector('.perfil__banner a[href="/home-memes"]') as any;

  bannerPerfil && bannerPerfil.addEventListener("click", ()=>{
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Content',
      'event_label': 'Dale cuerda a tus panas',
      'interaction':'true',
      'component_name': 'Dale cuerda a tus panas',
      'element_text': 'Dale cuerda a tus panas'
    });
  })
}

const pacoLoginLogout = () => {
  const loginForm = document.querySelector("#user-login-form");
  if (loginForm) {
    const btnLogin = loginForm.querySelector("#edit-send"),
      emailLogin: HTMLInputElement = loginForm.querySelector("#edit-name--2"),
      passLogin: HTMLInputElement = loginForm.querySelector("#edit-pass");

    if (btnLogin) {
      btnLogin.addEventListener("click", (e) => {
        if (
          passLogin.value == "" ||
          passLogin.value == " " ||
          passLogin.value == null
        ) {
        } else {
          // window.dataLayer.push({
          //   event: 'GAEvent',
          //   event_category: "Login",
          //   event_action: "Success",
          //   event_label: 'Email',
          //   userUid : window.CryptoJS.SHA256(emailLogin.value).toString(
          //     window.CryptoJS.enc.Hex
          //   ),
          // });
        }
      });
    }
  }

  const linkUser = document.querySelectorAll("a[href='/user'].nav-link--user");
  if (linkUser) {
    linkUser.forEach((link) => {
      link.href = "/perfil";
    });
  }

  const loggedUserLink = document.querySelector(
    ".nav-item.menu-item--expanded.dropdown"
  );
  if (loggedUserLink) {
    loggedUserLink.addEventListener("click", (e) => {
      loggedUserLink.classList.add("active-submenu-user-account");
    });

    const menuDrop = document.querySelector(".dropdown-menu");
    if (menuDrop) {
      menuDrop.addEventListener("mouseleave", () => {
        loggedUserLink.classList.remove("active-submenu-login");
      });
    }

    // const menuDrop = document.querySelector('.dropdown-menu')
    // if (menuDrop) {
    //   menuDrop.addEventListener('mouseleave', () => {
    //     loggedUserLink.classList.remove('active-submenu-login')
    //   })
    // }
  }

  // Open PopUp login
  let linksLogin = document.querySelectorAll(
    "a[href='/user/login'].nav-link--user-login"
  );
  if (linksLogin.length) {
    linksLogin.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        window.drupalLogin();
      });
    });
  }
};

/**
 * Global Functions
 */

window.drupalLogin = (loginLocation = 'N/A') => {
  closeForm();
  if (document.querySelector(".formPopUp-validate")) {
    let formularioLogin = document.querySelector(".formPopUp-validate");
    formularioLogin.classList.toggle("active-form");
    let btnformularioLogin = document.querySelector(".btn-user-validate");
    localStorage.setItem('openLoginLocation', loginLocation)
  }
};

window.closeLogin = (e: any) => {
  closeForm();
  localStorage.removeItem('openLoginLocation')
};

window.showLogin = (email: any) => {
  closeForm();
  let emailCont = document.getElementById("edit-name--2") as HTMLInputElement;
  emailCont.value = email;
  let formularioLogin = document.querySelector(".formPopUp-login");
  formularioLogin.classList.toggle("active-form");

  const inputEmail = document.querySelector(
    "#user-login-form input[name='name']"
  ) as HTMLInputElement;
  inputEmail.addEventListener("keyup", function () {
    const nextElement = inputEmail.nextElementSibling;
    const errorajaxform = nextElement.querySelector(
      ".error-ajax-form"
    ) as HTMLDivElement;
    errorajaxform.innerHTML = "";
  });

  const inputPass = document.querySelector(
    "#user-login-form input[name='pass']"
  ) as HTMLInputElement;
  inputPass.addEventListener("keyup", function () {
    const nextElement = inputPass.nextElementSibling;
    const errorajaxform = nextElement.querySelector(
      ".error-ajax-form"
    ) as HTMLDivElement;
    errorajaxform.innerHTML = "";
  });
};

window.showSignIn = (email: any) => {
  closeForm();
  let emailCont = document.getElementById("edit-mail") as HTMLInputElement;
  emailCont.value = email;
  let formularioLogin = document.querySelector(".formPopUp-register");
  formularioLogin.classList.toggle("active-form");
};
window.showPassword = (e: any) => {
  closeForm();
  let formularioLogin = document.querySelector(".formPopUp-pass");
  formularioLogin.classList.toggle("active-form");

  const inputEmail = document.querySelector(
    "#do-presidente-core-user-pass input[name='mail']"
  ) as HTMLInputElement;
  inputEmail.value = '';
  inputEmail.addEventListener("keyup", function () {
    const nextElement = inputEmail.nextElementSibling;
    const errorajaxform = nextElement.querySelector(
      ".error-ajax-form"
    ) as HTMLDivElement;
    errorajaxform.innerHTML = "";
  });
};
window.showCode = (e: any) => {
  let email = document.querySelector(".mail-codeform") as HTMLInputElement;
  email.value = e;
  closeForm();
  let formularioLogin = document.querySelector(".formPopUp-codepass");
  formularioLogin.classList.toggle("active-form");
};
window.changePassword = (e: any) => {
  closeForm();
  let email = document.querySelector(".mail-resetpassform") as HTMLInputElement;
  email.value = e;
  let formularioLogin = document.querySelector(".formPopUp-changepass");
  formularioLogin.classList.toggle("active-form");
};
window.backForm = (e: any) => {
  closeForm();
  window.drupalLogin();
};
window.closePopUps = (e: any) => {
  e.parentNode.parentNode.style.display = "none";
  e.parentNode.parentNode.classList.remove("active-form");
};
window.openPopUps = (e: any) => {
  e.parentNode.parentNode.classList.add("active-form");
};

window.copyText = (e: any) => {
  var copyText = document.getElementById("dataCoupon") as HTMLDivElement;
  navigator.clipboard.writeText(copyText.textContent);
  document.getElementById("closePopupCoupon").click();
};

const closeForm = () => {
  let formularios = document.getElementsByClassName("formPopUp") as any;
  var arrayform = [...formularios];
  arrayform.forEach((e) => {
    e.classList.remove("active-form");
  });
};

//active Link Menú header
const menuHeaderActive = () => {
  let url = window.location.pathname;
  let optionsMenu = document.querySelectorAll(
    "#menu__paco .menu__items--item .item-link a"
  ) as any;
  let arrayOptionsMenu = [...optionsMenu];

  if (optionsMenu) {
    for (let i = 0; i < arrayOptionsMenu.length; i++) {
      if (url != "/") {
        if (arrayOptionsMenu[i].href.includes(url)) {
          arrayOptionsMenu[i].classList.add("is-active");
        }
      }
    }
  }

  // active paco 1 - safary/iOS
  // const toogleMobile = document.querySelector('#menu__paco .menu__header--toggle') as HTMLElement
  // setTimeout(() => {
  //   if(toogleMobile) {
  //     toogleMobile.addEventListener('click', (event) => {
  //       event.preventDefault()
  //       event.stopPropagation()
  //       toogleMobile.classList.toggle('paco--change-icon')
  //       const headerWrapper = document.querySelector('#menu__paco .menu__paco--wrapper') as HTMLElement
  //       headerWrapper.classList.toggle('menu__paco--open')
  //       const body = document.querySelector('body') as HTMLElement
  //       body.classList.toggle('menu__body--open')
  //       document.querySelector('html').setAttribute('lang', 'es')
  //       })
  //   }
  // }, 5000)
};

const deleteh2 = () => {
  let h2 = document.querySelector('div[role="alert"] h2') as any;
  if(h2) document.querySelector('div[role="alert"]').removeChild(h2);
}


const params = new Proxy(new URLSearchParams(window.location.search), {
  get: (searchParams, prop) => searchParams.get(prop),
});

window.showGracias = (email: any) => {
  closeForm();
  let formularioLogin = document.querySelector(".thankyouPopup-register");
  formularioLogin.classList.add("active-form");
};
if(params.htht) {
  const htht = params.htht;
  window.history.replaceState({}, document.title, window.location.pathname);
  if(htht == 'presidenteStudiosButton') {
    showGracias();
  }
}
